import React from "react";

import editIcon from "images/icons/invite/edit.svg";
import deleteIcon from "images/icons/invite/delete.svg";

import { useTopicContext } from "../../../../contexts/TopicContext";
import routes from "../../../../app/routes";

export default function Actions({ row }) {
  const { dispatch, actions } = useTopicContext();

  const deleteTopic = (e, row) => {
    swal(
      {
        title: "",
        text: "Do you want to delete this topic?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== "A") {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.deleteTopic(dispatch, row.id);
        }
      }
    );
  };

  return (
    <div>
      <a href={routes.api.topics.edit(row.id)} className="mr10">
        <img src={editIcon} />
      </a>

      <a onClick={(e) => deleteTopic(e, row)}>
        <img src={deleteIcon} />
      </a>
    </div>
  );
}
